<template>
    <li
        class="product-filter-color"
        :class="{ 'selected-color': modelValue }"
    >
        <button
            type="button"
            class="product-filter-color-btn cursor-pointer"
            :title="attrObj.name"
            :aria-label="attrObj.name"
            :aria-pressed="modelValue"
            @click="onChange(!modelValue)"
        >
            <ColorSwatch
                :color="attrObj.colors"
                :width="32"
                :height="32"
                :disable-border="modelValue"
            ></ColorSwatch>
        </button>
    </li>
</template>

<script lang="ts" setup>
    import type {
        ProductFilterAttributeValue
    } from '~/types';
    import ColorSwatch from '~/components/color/ColorSwatch/ColorSwatch.vue';
    
    defineProps<{
        modelValue: boolean;
        attrObj: ProductFilterAttributeValue;
    }>();

    const emit = defineEmits<{
        'update:model-value': [value: boolean];
    }>();

    function onChange(val: Nullable<boolean>): void {
        emit('update:model-value', Boolean(val));
    }
</script>

<style lang="scss">
.product-filter-color {
    $swatch-size: 42px;
    
    width: $swatch-size;
    height: $swatch-size;
    min-width: $swatch-size;
    min-height: $swatch-size;
    padding: 1px;
    cursor: pointer;
    border-radius: 4px;
    border: 4px solid transparent;

    &.selected-color {
        border: 4px solid rgba(var(--v-theme-primary), 1);
    }

    &-btn {
        display: block;
        padding: 0;
        border: 0;
        background: none;
        line-height: 0;

        &:focus-visible {
            outline: 2px solid rgba(var(--v-theme-on-surface), 1);
            outline-offset: 2px;
        }
    }

    span {
        visibility: hidden;
    }
}
</style>
